// gatsby-browser.js
import React from 'react';
import { MountedAppProvider } from './src/hooks/useAppMounted';

export const wrapRootElement = ({ element }) => {
  return <MountedAppProvider>{element}</MountedAppProvider>;
};
